import { FunctionComponent, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useQueryParams } from 'hooks';
import { TransportationTabId } from './Tabs/TransportationTabs';
import { TransportationNavbar } from './Tabs/TransportationNavbar';
import TransportationServices from './Services/TransportationServices';
import TransportationVehicles from './Vehicles/TransportationVehicles';
import styles from './TransportationComponent.module.scss';

const TransportationComponent: FunctionComponent = () => {
    const queryParams = useQueryParams();
    const history = useHistory();

    // State: which tab is currently selected (default: services)
    const [selectedTab, setSelectedTab] = useState<TransportationTabId>('services');

    // Read ?tab=vehicles param on mount and switch tab
    useEffect(() => {
        const tabParam = queryParams.get('tab');

        if (tabParam === 'vehicles' || tabParam === 'services') {
            setSelectedTab(tabParam as TransportationTabId);
        }

        // Clean query params after processing (keeps URL clean)
        if (tabParam) {
            history.replace({
                search: ''
            });
        }
    }, [queryParams, history]);

    // Render content based on selected tab
    const renderTabContent = () => {
        switch (selectedTab) {
            case 'services':
                return <TransportationServices />;
            case 'vehicles':
                return <TransportationVehicles />;
            default:
                return <TransportationServices />;
        }
    };

    return (
        <div className={styles.container}>
            <TransportationNavbar
                selectedTab={selectedTab}
                onTabChange={setSelectedTab}
            />
            <div className={styles.contentWrapper}>{renderTabContent()}</div>
        </div>
    );
};

export default TransportationComponent;
